module.exports = __webpack_public_path__ + "static/media/cat-17.c6e37caf.jpg";